import React from 'react';
import { Formik } from 'formik';
import {
    withStyles,
    Button,
    Typography,
    CircularProgress,
    FormControl, InputLabel, Select, MenuItem, Checkbox, FormGroup, FormControlLabel
} from '@material-ui/core';
import * as Yup from 'yup';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    rootEdit: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },
    submit: {
        width: '100%',
        marginTop: '10px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    formControl: {
        width: '100%'
    },

    datePicker: {
        width: '100%'
    }
});

const PlansForm = props => {
    const {
        classes,
        formSettings,
        initialValues,
        handleSubmit,
        loading,
        plans,
        planVersions,
        translations,
        setPlanVersions,
        onFetchPlanVersions,
        activeCustomerID
    } = props;

    return (
        <>
            {plans.length!==0? <Formik
                initialValues={initialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, isValid, dirty, isSubmitting, handleSubmit, handleChange, setValues } = formikProps;

                    const handlePlanChange = async (e) => {
                        setValues({...values, PlanID: e.target.value, VersionID: values.StickWithPreviousVersion? null : ""});
                        const versions = await onFetchPlanVersions({ActiveCustomerID: activeCustomerID, PlanID: e.target.value});
                        setPlanVersions(versions.data?.map((version) => {
                            return { value: version.VersionID, label: `${version.Name} (${version.VersionID})` }
                        }));
                    }

                    const handleCheckbox = async (e) => {
                        const isChecked = e.target.checked;
                        setValues({...values, StickWithPreviousVersion: isChecked, VersionID: isChecked? null : ""});
                        const versions = await onFetchPlanVersions({ActiveCustomerID: activeCustomerID, PlanID: values?.PlanID});
                        setPlanVersions(versions.data?.map((version) => {
                            return { value: version.VersionID, label: `${version.Name} (${version.VersionID})` }
                        }));
                    }

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={'h6'}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>

                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["please_select_billing_account_plan"] || "Please select billing account plan"}</InputLabel>
                                <Select
                                    name="PlanID"
                                    margin={"dense"}
                                    value={values?.PlanID || ''}
                                    onChange={handlePlanChange}
                                >
                                    {(plans ? plans : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color={'primary'}
                                            margin={"dense"}
                                            name={"StickWithPreviousVersion"}
                                            checked={!!values.StickWithPreviousVersion || false}
                                            onChange={handleCheckbox}
                                            disabled={!values.PlanID}
                                        />
                                    }
                                    label={`${translations['stick_with_previous_version'] || 'Stick with previous version'}`}
                                />
                            </FormGroup>
                            {values.StickWithPreviousVersion && <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["please_select_plan_version"] || "Please select plan version"}</InputLabel>
                                <Select
                                    name="VersionID"
                                    margin={"dense"}
                                    value={values?.VersionID || ''}
                                    onChange={handleChange}
                                >
                                    {(planVersions ? planVersions : []).map(option => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>}
                            {formSettings.ButtonSubmit ? (
                                <Button
                                    className={classes.submit}
                                    variant="contained"
                                    color={formSettings.ButtonSubmit.Color}
                                    type="submit"
                                    disabled={loading || !(isValid && dirty) || isSubmitting}
                                >
                                    {isSubmitting || loading ? (
                                        <CircularProgress size={24} />
                                    ) : (
                                            formSettings.ButtonSubmit.Title
                                        )}
                                </Button>
                            ) : null}
                        </form>
                    );
                }}
            </Formik> : <Typography variant={"body1"}>{translations["no_plans_to_assign"] || "No plans to assign"}</Typography>}
        </>
    );
};

export default withStyles(styles, { withTheme: true })(PlansForm);